import {
  Box,
  Button,
  Stack,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { RouterLink } from "components/router-link";
import PageNotFoundImage from "assets/images/404.svg";
import CustomAuthCardLayout from "global/components/CustomAuthCardLayout/CustomAuthCardLayout";
import { useTitle } from "utils/UseTitle";
import title from "global/constants/TitleConstants";

const PageNotFound = () => {
  useTitle(title.PAGE_NOT_FOUND);
  const mdUp = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  const getBody = () => {
    return (
      <CustomAuthCardLayout IsCustomAuthCardLayout={true}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginBottom: 2,
          }}
        >
          <Box
            alt="Page not found illustration"
            component="img"
            src={PageNotFoundImage}
            sx={{
              height: "auto",
              maxWidth: "100%",
              width: 350,
            }}
          />
        </Box>
        <Typography component="h1" align="center" variant={mdUp ? "h1" : "h4"}>
          The page you are looking for isn’t here
        </Typography>
        <Typography align="center" color="text.secondary" sx={{ mt: 2, mx: 2 }}>
          You either tried some shady route or you came here by mistake.
          Whichever it is, try using the navigation.
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 6,
          }}
        >
          <Button variant="contained" component={RouterLink} href={"/"}>
            Back to Home
          </Button>
        </Box>
      </CustomAuthCardLayout>
    );
  };

  return getBody();
};

export default PageNotFound;
